<script>
  export let year
  export let age

  function getAgeString(ageNumber) {
    const ageStringMap = [
      'null',
      'ett',
      'to',
      'tre',
      'fire',
      'fem',
      'seks',
      'sju',
      'åtte',
      'ni',
      'ti',
      'elleve',
      'tolv',
      'tretten',
      'fjorten',
    ]
    return ageStringMap[ageNumber]
  }
</script>

<div class="header">
  <h2 class="header-title">
    {#if getAgeString(age) && typeof age !== 'undefined' && age !== 0}
      Du var <strong>{getAgeString(age)} år</strong> i
    {/if}<span class="year">{year}</span>
  </h2>
</div>

<style>
  .header {
    position: relative;
    text-align: center;
  }

  .header-title {
    font-size: 20px;
    font-weight: normal;
  }

  .year {
    display: block;
    /* text-align: center; */
    font-size: 70px;
    font-weight: 890;
  }
</style>
